












































import Vue from "vue";
import { Component, Watch } from "vue-property-decorator";
import { AppModule } from "@/store/modules/app"
import { PaintingByNumbersModule, PaintingFormat } from '@/store/modules/paintingByNumbers';
import PaintingByNumbersEditorPassive from "@/components/products/malennachzahlen/PaintingByNumbersEditorPassive.vue"
import BoxImageBig from '@/components/products/malennachzahlen/BoxImageBig.vue'
import BoxImageOverlayBig from '@/components/products/malennachzahlen/BoxImageOverlayBig.vue'

@Component({
  name: "painting-by-numbers-preview",
  components: {
    PaintingByNumbersEditorPassive,
    BoxImageBig,
    BoxImageOverlayBig
  }
})

export default class PaintingByNumbersPreview extends Vue {
  private hash: string = ""
  matrix3d: string = "1.0,0.0,0.0,0.0,0.0,1.0,0.0,0.0,0.0,0.0,1.0,0.0,0.0,0.0,0.0,1.0"
  transformedOffsetX: number = 0
  transformedOffsetY: number = 0
  titleColor: string = "rgb(255,255,255)"
  titleOffsetX: number = 0
  titleOffsetY: number = 0
  titleFontSize: string = "13px"
  titleMatrix3d: string = "1.0,0.0,0.0,0.0,0.0,1.0,0.0,0.0,0.0,0.0,1.0,0.0,0.0,0.0,0.0,1.0"

  get availableDesigns() {
    return PaintingByNumbersModule.availableDesigns
  }

  get imageEditorWidth() {
    return PaintingByNumbersModule.imageEditorWidth
  }

  get imageEditorHeight() {
    return PaintingByNumbersModule.imageEditorHeight
  }

  get show() {
    return AppModule.showPreview;
  }

  get imgReady() {
    return this.hash !== '' && this.dru1AssetId !== ''
  }

  get isLandscapeFormat() {
    return PaintingByNumbersModule.isLandscapeFormat
  }

  get isSquare() {
    return this.parts === '100000'
  }

  get title() {
    return PaintingByNumbersModule.title;
  }

  get designNr() {
    return PaintingByNumbersModule.boxDesign
  }

  get parts() {
    return PaintingByNumbersModule.parts
  }

  get dru1AssetId() {
    return PaintingByNumbersModule.previewAssetId
  }

  get imageAssetId() {
    let usage = "paintingimage"
    let info = PaintingByNumbersModule.paintingUsageAndInfo[usage]
    if (info) {
      let onlyAssetId = info.assetId
      if (onlyAssetId !== undefined) {
        return onlyAssetId
      }
    }
    return ''
  }

  get sessionId() {
    if (AppModule.session && AppModule.session.sessionId) {
      return AppModule.session.sessionId
    }
    return ""
  }

  @Watch('show')
  showChanged(newShow: boolean) {
    if (newShow) {
      this.$nextTick(() => {
        this.setImgAndTitle()
        this.resized()
        if (navigator.userAgent.match(/(iPhone|iPad|Android)/)) {
          const editorWrapper = document.getElementById('editorWrapperPreview');
          if (editorWrapper && !editorWrapper.classList.contains('rv-blur')) {
            editorWrapper.classList.add('rv-blur');
          }
        }
      })
    }
  }

  get format() {
    if (PaintingByNumbersModule.format === PaintingFormat.LANDSCAPE) {
      return 'landscape'
    }
    return 'portrait'
  }

  setImgAndTitle() {
    this.setUserImg()
    this.setTitleTransform()
  }

  setUserImg() {
    this.setMatrix3d()
    this.setTransformedOffsetX()
    this.setTransformedOffsetY()
  }

  setTitleTransform() {
    this.setTitleOffsetX()
    this.setTitleOffsetY()
    this.setTitleFontSize()
    this.setTitleMatrix3d()
    this.setTitleColor()
  }

  setMatrix3d() {
    if (this.parts === '100000') {
      this.matrix3d = '0.8366139316,-0.0894048879,0.0000000000,0.0000519811,0.0699120090,0.8855220326,0.0000000000,0.0000601616,0.0000000000,0.0000000000,1.0000000000,0.0000000000,1.5000000000,18.5000000000,0.0000000000,1.0000000000'
    } else if (this.parts === '100001') {
      if (!this.isLandscapeFormat) {
        this.matrix3d = '0.8354582619,-0.0845233949,0.0000000000,0.0000508142,0.0681617941,0.7819934113,0.0000000000,0.0000580297,0.0000000000,0.0000000000,1.0000000000,0.0000000000,0.0000000000,13.0000000000,0.0000000000,1.0000000000'
      } else {
        this.matrix3d = '0.7694533344,-0.0775000000,0.0000000000,0.0000291068,0.0603327961,0.7760591555,0.0000000000,0.0000812282,0.0000000000,0.0000000000,1.0000000000,0.0000000000,0.0000000000,15.5000000000,0.0000000000,1.0000000000'
      }
    } else {
      this.matrix3d = '1.0,0.0,0.0,0.0,0.0,1.0,0.0,0.0,0.0,0.0,1.0,0.0,0.0,0.0,0.0,1.0'
    }
  }

  setTransformedOffsetX() {
    if (this.parts === '100000') {
      this.transformedOffsetX = 166.5
    } else if (this.parts === '100001') {
      if (!this.isLandscapeFormat) {
        this.transformedOffsetX = 142
      } else {
        this.transformedOffsetX = 196.5
      }
    } else {
      this.transformedOffsetX = 0
    }
  }

  setTransformedOffsetY() {
    if (this.parts === '100000') {
      this.transformedOffsetY = 169
    } else if (this.parts === '100001') {
      if (!this.isLandscapeFormat) {
        this.transformedOffsetY = 200.5
      } else {
        this.transformedOffsetY = 230.5
      }
    } else {
      this.transformedOffsetY = 0
    }
  }

  setTitleOffsetX() {
    if (this.parts === '100000') {
      this.titleOffsetX = 42
    } else if (this.parts === '100001') {
      if (!this.isLandscapeFormat) {
        this.titleOffsetX = 17
      } else {
        this.titleOffsetX = 17
      }
    }
  }

  setTitleOffsetY() {
    if (this.parts === '100000') {
      this.titleOffsetY = 569
    } else if (this.parts === '100001') {
      if (!this.isLandscapeFormat) {
        this.titleOffsetY = 548
      } else {
        this.titleOffsetY = 517
      }
    }
  }

  setTitleFontSize() {
    if (this.parts === '100000') {
      this.titleFontSize = '13px'
    } else if (this.parts === '100001') {
      if (!this.isLandscapeFormat) {
        this.titleFontSize = '8px'
      } else {
        this.titleFontSize = '8px'
      }
    }
  }

  setTitleMatrix3d() {
    if (this.parts === '100000') {
      this.titleMatrix3d = '1.0000000000,-0.1309523810,0.0000000000,0.0000000000,0.0000000000,1.0000000000,0.0000000000,0.0000000000,0.0000000000,0.0000000000,1.0000000000,0.0000000000,0.0000000000,0.0000000000,0.0000000000,1.0000000000'
    } else if (this.parts === '100001') {
      if (!this.isLandscapeFormat) {
        this.titleMatrix3d = '1.0000000000,-0.1142857143,0.0000000000,0.0000000000,0.0000000000,1.0000000000,0.0000000000,0.0000000000,0.0000000000,0.0000000000,1.0000000000,0.0000000000,0.0000000000,0.0000000000,0.0000000000,1.0000000000'
      } else {
        this.titleMatrix3d = '1.0000000000,-0.1119047619,0.0000000000,0.0000000000,0.0000000000,1.0000000000,0.0000000000,0.0000000000,0.0000000000,0.0000000000,1.0000000000,0.0000000000,0.0000000000,0.0000000000,0.0000000000,1.0000000000'
      }
    }
  }

  setTitleColor() {
    for (let i = 0; i < this.availableDesigns.length; i++) {
      for (let j = 0; j < this.availableDesigns[i].length; j++) {
        if (this.availableDesigns[i][j].designNr === this.designNr) {
          let titleColor = this.availableDesigns[i][j].titleColor
          if (titleColor) {
            this.titleColor = '#' + titleColor
          }
        }
      }
    }
  }

  onClose() {
    AppModule.SetShowPreview(false);
  }

  resized() {
    let width = window.innerWidth;
    let height = window.innerHeight;
    let scale = 1;
    let innerScale = 1
    let innerPortrairScale = 1
    if (width < 800) {
      if (width > height) {
        scale = (height - 130) / 700
        innerScale = 1
      } else {
        scale = width / (width + 100)
        if (scale < 1) {
          innerScale = scale * 5.14520305 - 3.57
          innerPortrairScale = scale * 5.27 - 3.45 < 1 ? scale * 5.27 - 3.45 : 1

        }
      }
    } else if (height < 800) {
      scale = (height - 100) / 700
      innerScale = 1
    }
    if (this.$refs.container) {
      (this.$refs.container as HTMLElement).style.transform =
        "scale(" + scale + ")";
    }
    let previewChildren = document.getElementsByClassName('preview-child')
    Array.from(previewChildren).forEach((child) => {
      if (this.isLandscapeFormat) {
        (child as HTMLElement).style.transform = "scale(" + innerScale + ") translate(0,-50%)";
      } else {
        (child as HTMLElement).style.transform = "scale(" + innerPortrairScale + ") translate(0,-50%)";
      }
    })
  }

  mounted() {
    const imgBoxBig = document.getElementById('imgBoxBig')
    if (imgBoxBig) {
      imgBoxBig.addEventListener('load', this.setImgAndTitle)
    }
    this.setImgAndTitle()
    window.addEventListener("resize", this.resized)
    this.resized()
  }

  beforeDestroy() {
    const imgBoxBig = document.getElementById('imgBoxBig')
    if (imgBoxBig) {
      imgBoxBig.removeEventListener('load', this.setImgAndTitle)
    }
    window.removeEventListener("resize", this.resized)
  }
}
